import React, { lazy } from 'react';

import HomeIcon from '@mui/icons-material/HomeOutlined';

import Breadcrumb from '@common/components/breadcrumb/breadcrumb';
import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';
import ANALYSIS_ROUTE_CONFIG from '@aware/v2-routes/analysis';
import ASSESSMENTS_ROUTE_CONFIG from '@aware/v2-routes/assessments';
import ITEM_BANK_ROUTE_CONFIG from '@aware/v2-routes/item-bank';
import STUDENTS_ROUTE_CONFIG from '@aware/v2-routes/students';

export const V2_ROUTE_CONFIG = {
  home: {
    title: null, // No section heading
    overview: {
      path: V2_ROUTE_PAGES.overview,
      icon: <HomeIcon />,
      title: 'Overview',
      component: lazy(
        () =>
          import(
            /* webpackChunkName: "aware-overview-page" */ './pages/v2-home/overview/overview'
          )
      ),
      routes: [
        {
          path: '/',
          breadcrumb: () => <Breadcrumb title="Aware" to={V2_ROUTE_PAGES.overview} />,
          component: null,
          exact: true
        }
      ]
    }
  },
  analysis: ANALYSIS_ROUTE_CONFIG,
  assessments: ASSESSMENTS_ROUTE_CONFIG,
  itemBank: ITEM_BANK_ROUTE_CONFIG,
  students: STUDENTS_ROUTE_CONFIG
};
